module.exports = __webpack_public_path__ + "img/cb-n.19a40c22.png";